<mat-toolbar color="primary">
  <span id="kopier-møte-dialog-tittel">{{ "Kopier møte"|translate }}</span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@switch (modus()){
  @case ('skjema'){
    <form [formGroup]="skjema" (ngSubmit)="kopier()" class="e2e-kopiermøteskjema">
    <mat-dialog-content class="skjema e2e-kopiermøtedialog">
      @if(harFeil()){
        <inline-melding type="feil">
          <p>{{'Møte kunne ikke kopieres til følgende grupper:'|translate }}</p>
          <ul>
          @for(feil of feilPerGruppe; track feil.gruppe.id){
            <li>
              <span>{{ '{tittel} i {organisasjonsnavn}' | translate: {tittel:feil.gruppe.tittel, organisasjonsnavn:feil.gruppe.organisasjonsnavn} }}: </span>
              <span class="valideringsfeil">{{feil.valideringsfeil}}</span>
            </li>
          }
          </ul>
        </inline-melding>
      }

      <p class="info">
        {{ 'Kopier {tittel} {nummer} i {gruppetittel} i {organisasjonsnavn} med' | translate: {nummer:moete.nummer, tittel:moete.tittel, gruppetittel:gruppe(moete).tittel, organisasjonsnavn:gruppe(moete).organisasjonsnavn} }}
        <span class="tellere">{{ '{antsaker} saker, {antbeslutninger} beslutninger og {antdokumenter} saksdokumenter' | translate: {antsaker:moete.saker.length, antbeslutninger:antallBeslutninger, antdokumenter:antallDokumenter} }}</span>
        {{ 'til følgende grupper'|translate}}
      </p>

      <fieldset>
        <mat-form-field class="gruppevelger">
          <mat-label>{{ "Velg grupper"|translate }}</mat-label>
          <velg-gruppe [skjemakontroll]="skjema.controls.grupper" [grupper]="tilgjengeligeGrupper" multiple="true"/>
        </mat-form-field>

        <mat-form-field class="dato">
          <mat-label>{{ "Velg møtedato"|translate }}</mat-label>
          <dato-klokkeslett-velger [formControl]="skjema.controls.dato" #datoklokkeslett/>
          @if (datoklokkeslett.harFeil()) {
            <mat-error data-testid="feil">{{ datoklokkeslett.foersteFeil() }}</mat-error>
          }
        </mat-form-field>
      </fieldset>

      <tips>
        <p>
          {{'Alle saker og dokumenter blir kopiert til valgte grupper, inklusive referat-/protokolltekster.'|translate}}<br>
          {{'Tilgangsbegrensninger, oppgaver og kommentarer blir ikke kopiert.'|translate}}<br>
          {{'Møtedeltakere som ikke er medlem i mottakende grupper blir ikke kopiert.'|translate}}<br>
          {{'Temaer og sakstyper som ikke eksisterer i mottakende grupper blir opprettet automatisk.'|translate}}<br>
        </p>
      </tips>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div>
        <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
        <button mat-raised-button color="primary" type="submit" cdkFocusInitial [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()" spinnerTekst="{{'Kopierer...'|translate}}" data-testid="lagre">
          {{ 'Kopier møte til {antall} gruppe(r)'|translate: {antall: skjema.value.grupper.length} }}
        </button>
      </div>
    </mat-dialog-actions>
    </form>
  }

  @case ('kvittering'){
    <mat-dialog-content class="kvittering e2e-bekreftelse">
      <p>
        {{ '{antall} møte(r) opprettet' | translate: {antall: opprettedeMoeter.length} }}:
      </p>
      <ul>
      @for(moete of opprettedeMoeter; track moete.id){
        <li>
          <a (click)="gaaTilMoete(moete)">{{ '{tittel} {nummer} i {gruppetittel} i {organisasjonsnavn}' | translate: {nummer:moete.nummer, tittel:moete.tittel, gruppetittel:gruppe(moete).tittel, organisasjonsnavn:gruppe(moete).organisasjonsnavn} }}</a>
        </li>
      }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div>
        <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
          {{ 'Lukk'|translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }
}
